import {
    AVAILABLE_UNITS_REQUEST,
    AVAILABLE_UNITS_SUCCESS,
    AVAILABLE_UNITS_ERROR,
    AVAILABLE_UNITS_SET_FILTER,
    AVAILABLE_UNITS_SET_SORT,
    AVAILABLE_UNITS_SELECT_UNIT,
    UNIT_STATE_REACTIVE_UPDATE,
    UNIT_STATE_REACTIVE_OPEN_TOGGLE,
} from 'state/actions/available_units'

import { CLAN_UNITS_SUCCESS } from 'state/actions/clan_units'
import {
    ENABLE_MATCHING,
    BATTLE_MODE_FILTER_SET,
} from 'state/actions/players_matching'

import { getFilter, saveFilter } from 'state/actions/helpers/available_units'

import { UNIT_TYPES } from 'constants'

const defaultFilter = {
    level: 6,
    unitType: UNIT_TYPES.SORTIE,
    hasFreeSlots: true,
    waitingForPlayers: true,
}

const initialState = {
    filter: getFilter(defaultFilter),
    sort: {
        order: null,
        prop: null,
    },
    loading: false,
    loaded: false,
    meta: {
        battle_modes_settings: [],
        fort_battles: {
            peripheries: [],
        },
        sorties: {
            players_matching_available_before: 10 * 60,
            peripheries: [],
        },
    },
    showLoader: false,
    units: [],
    errorMessage: '',
    selectedUnitId: null,
}


export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case CLAN_UNITS_SUCCESS: {
        return {
            ...state,
            meta: action.payload.meta,
        }
    }
    case ENABLE_MATCHING: {
        return {
            ...state,
            selectedUnitId: null,
        }
    }
    case UNIT_STATE_REACTIVE_UPDATE: {
        const unitToReplace = action.payload.unit
        const units = state.units.map(unit => (unit.id === unitToReplace.id) ? unitToReplace : unit)
        return {
            ...state,
            units,
        }
    }
    case UNIT_STATE_REACTIVE_OPEN_TOGGLE: {
        const units = state.units.map(unit => {
            if (unit.id !== action.payload.id) return unit
            return {
                ...unit,
                is_open: action.payload.is_open,
            }
        })
        return {
            ...state,
            units,
        }
    }
    default:
        return availableUnitsReducer(state, action)
    }
}

function availableUnitsReducer(state = initialState, action = {}) {
    switch (action.type) {
    case AVAILABLE_UNITS_REQUEST: {
        const { showLoader } = action.payload
        return {
            ...state,
            loading: true,
            showLoader,
            errorMessage: '',
        }
    }
    case AVAILABLE_UNITS_SUCCESS: {
        const { meta, units } = action.payload
        return {
            ...state,
            loading: false,
            loaded: true,
            showLoader: false,
            meta,
            units,
        }
    }
    case AVAILABLE_UNITS_ERROR: {
        return {
            ...state,
            loading: false,
            loaded: true,
            showLoader: false,
            errorMessage: action.payload.errorMessage,
        }
    }
    case AVAILABLE_UNITS_SET_FILTER: {
        saveFilter(action.payload.filter)

        return {
            ...state,
            filter: action.payload.filter,
        }
    }
    case BATTLE_MODE_FILTER_SET: {
        const filter = {
            ...state.filter,
            level: action.payload.vehicle_level,
            unitType: UNIT_TYPES.SORTIE,
        }

        saveFilter(filter)

        return {
            ...state,
            filter,
        }
    }
    case AVAILABLE_UNITS_SET_SORT: {
        return {
            ...state,
            sort: action.payload.sort,
        }
    }
    case AVAILABLE_UNITS_SELECT_UNIT: {
        return {
            ...state,
            selectedUnitId: action.payload.unitId,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/units/available_units.js